var exports = {
  "kL": "xe7b6e3d6--18079c--container",
  "AS": "xe7b6e3d6--18079c--item",
  "PS": "xe7b6e3d6--18079c--house",
  "jB": "xe7b6e3d6--18079c--newbuilding",
};

module.exports = exports;
